// extracted by mini-css-extract-plugin
export default {"box":"style_box__esC0t","Input":"style_Input__ALE7e","but":"style_but__IKWkh","check":"style_check__7u9na","cityy":"style_cityy__HF9OB","Inp":"style_Inp__oMFe3"};